import React from 'react';
import { UserDataKeys } from '../../screens/Profile/UserDataKeys';
import { DataInput } from '../../screens/Profile/data-input/DataInput';
import { ValidatedDataInputProps } from './ValidatedDataInput';
import {
  loginHelper,
  emailLoginLabel
} from '../../basic/LoginLabel';
import { isValidEmail, ValidatorResponse } from './Validator';

export const minLength = 6;
export const maxLength = 100;
export const TEST_ID = {
  MAIN: 'login-input'
};

export interface LoginInputProps extends ValidatedDataInputProps {
  registerErrorMessage?: string
}

export const LoginInput: React.FC<LoginInputProps> = props => {
  const { whenValidated } = props;
  return (
    <DataInput
      validator={async (value: string) => {
        const isValid: ValidatorResponse = isValidEmail(value);
        if (!isValid.response) {
          whenValidated?.(false);
          throw new Error(isValid.reason);
        }
        whenValidated?.(true);
      }}
      // Mark this as a guaranteed value (defaultProp) so that TS is happy
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      dataLabel={props.dataLabel!}
      {...props}
    />
  );
};

LoginInput.defaultProps = {
  dataLabel: emailLoginLabel,
  name: UserDataKeys.login,
  testId: TEST_ID.MAIN,
  id: 'login-input',
  required: true,
  helperMessage: `${minLength}-${maxLength} chars, ${loginHelper.toLowerCase()}`,
  whenValidated: () => {return;}
};
